import { Card, Stack, Text } from '@tiendanube/components';
import { emptyIsNullInText } from 'commons/utils';
import useTranslationOrders from 'domains/Orders/useTranslationOrders/useTranslationOrders';

export interface BillingAddressCardInterface {
  billingName: string | null;
  zipcode: string | null;
  street: string | null;
  number: string | null;
  floor: string | null;
  city: string | null;
  province: string | null;
  country: string | null;
}

interface BillingAddressCardProps {
  billingAddressData: BillingAddressCardInterface;
}

function BillingAddressCard({ billingAddressData }: BillingAddressCardProps) {
  const t = useTranslationOrders();
  const hasBillingAddress = !!billingAddressData.street;

  return (
    <Card title={t('abandonedCarts.billingAddressCard.title')} isCollapsible>
      {hasBillingAddress ? (
        <Stack column align="flex-start" spacing="tight">
          <Stack.Item>
            <Text block>{billingAddressData.billingName}</Text>
          </Stack.Item>
          <Stack.Item>
            <Text size="caption" appearance="light" block>
              {`${t('abandonedCarts.billingAddressCard.address')}`}
            </Text>
            <Text block>
              {`
              ${billingAddressData.street} 
              ${emptyIsNullInText(billingAddressData.number as string)} 
              ${billingAddressData.floor} 
              (${billingAddressData.zipcode})
            `}
            </Text>
            <Text block>
              {`${billingAddressData.city}, ${billingAddressData.province}, ${billingAddressData.country}`}
            </Text>
          </Stack.Item>
        </Stack>
      ) : (
        <Text appearance="light">
          {t('abandonedCarts.billingAddressCard.notAvailable')}
        </Text>
      )}
    </Card>
  );
}

export default BillingAddressCard;
